import type { GetCourseReviews200ReviewsItemReviewerBasicInfo } from './getCourseReviews200ReviewsItemReviewerBasicInfo';
import type { GetCourseReviews200ReviewsItemReviewerSocial } from './getCourseReviews200ReviewsItemReviewerSocial';

/**
 * 리뷰 작성자 요약 정보
 */
export type GetCourseReviews200ReviewsItemReviewer = {
  /** 사용자 기본 정보 */
  basicInfo: GetCourseReviews200ReviewsItemReviewerBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetCourseReviews200ReviewsItemReviewerSocial;
};
